import React, { useCallback } from "react";
import { socket } from "../../../lib/socketio";
import { GroupTemplate } from "../../Definitions/cl";
import { Grid, Label } from "semantic-ui-react";
import Footer from "../Footer";
import StackColumn from "../../Monitor/Data/StackColumn";
import ConfirmMacro from "../../Macros/ConfirmMacro";

import { useSelector, useDispatch } from "react-redux";
import { setCurrentPLC, setUserArray } from "../../../actions/headerActions";
import { useLocation } from "react-router-dom";
import RequestAccessModal from "../../RequestAccess/RequestAccessModal";
import { setUser } from "../../../actions/navActions";

const SVMIO = () => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);

  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    if (tags.length === 0) {
      socket.emit("get tag names", [{ display_id: 18 }, { display_id: 1 }]);
      socket.on("receive tag names", (data) => {
        settags(data.tags_data);
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);

  const FooterTags = tags.flatMap((t) =>
    // t.page_name === 'Footer' ? [t] : []);
    t.display_id === 1 ? [t] : [],
  );

  const GenTags = tags.flatMap((t) =>
    // t.page_name === 'Substack Voltage Monitor' ? [t] : []);
    t.display_id === 18 ? [t] : [],
  );

  const display = GenTags.map((t) => t.page_name);
  const filterTags = GenTags.filter((c) => c.id !== 2820 && c.id !== 2823); // no 2820, 2823 on main tags DP
  const SVMTags = GroupTemplate(filterTags, "tag_display_subgroup");
  // const SVMTags = GroupTemplate(GenTags.filter(el=> el.id !== 2820 || el.id !== 2823), "tag_display_subgroup");
  const ClearIds = Object.keys(SVMTags[0]).map((i) =>
    SVMTags[0][i].map((r) => r.id),
  );

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  const rows = 1;
  const columns = [];
  const length = SVMTags[0].length;
  let i = 0;
  while (i < length) {
    columns.push(SVMTags[0].slice(i, i + rows));
    i += rows;
  }

  const getColor = (parm) => {
    if (parm === 0) {
      return "green";
    } else {
      return "red";
    }
  };

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <div style={styles.div}>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <h1 style={styles.header}>{display[0]}</h1>
      {/* <div style={styles.menu}>
                <ConfirmMacro
                    option={2}
                    channel={'SVM-H2 RESET (TBD)'}
                />
            </div> */}
      {/* <div style={{alignItems : 'right'}}>
                <div style={{float:'right'}}>*/}
      <span
        style={{
          alignSelf: "flex-end",
          paddingBottom: "0px",
          marginBottom: "0px",
          marginTop: "0px",
          marginRight: "20px",
        }}
      >
        {" "}
        SVM COMM FAULT
        <Label
          circular
          horizontal
          empty
          size="large"
          color={getColor(data[2820])}
          style={{ marginLeft: "10px" }}
        />
      </span>
      <span
        style={{
          alignSelf: "flex-end",
          color: data[2823] === 0 || data[2823] === 1 ? "green" : "red",
          paddingBottom: "0px",
          marginBottom: "0px",
          marginRight: "20px",
        }}
      >
        {" "}
        SVM TCP CRS Word : {data[2823]}
      </span>
      <span
        style={{
          alignSelf: "flex-end",
          color: "yellow",
          paddingTop: "0px",
          marginTop: "0px",
          marginRight: "20px",
        }}
      >
        {" "}
        0 or 1 means communication successfully established
      </span>
      {/* </div>
            </div> */}
      <Grid inverted divided centered columns="equal" style={styles.grid}>
        {columns.map((c, i) => (
          <StackColumn index={i} column={c} data={data} />
        ))}
      </Grid>
      <Footer tags={FooterTags} data={data} option={"MAIN"} />
    </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  header: {
    marginBottom: "15px",
  },
  toggle: {
    marginTop: "20px",
    marginBottom: "30px",
  },
  menu: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    paddingBottom: "8px",
    marginBottom: "0px",
  },
  grid: {
    marginTop: "10px",
    paddingBottom: "0",
    marginBottom: "10px",
  },
  innerdiv: {
    alignItems: "center",
    flex: "1 1 auto",
    paddingBottom: "10px",
    width: "100%",
  },
};

export default SVMIO;
